<template>
  <div class="stats__list">
    <div v-for="(value, stat_key) in statsData" :key="stat_key" :class="getStatClass(stat_key)">
      <span class="stats__item__label">{{ $t(`stats.values.${stat_key}`) }}</span>
      <span class="stats__item__value">{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatsItems",

  props: {
    statsData: Object,
  },

  methods: {
    getStatClass(stat) {
      return ["stats__item", `stat-${stat}`];
    },
  },
};
</script>
